import AssistantPanelAskButton from "components/AssistantPanel/AskButton";
import { buildPolicyOverviewPrompt } from "components/AssistantPanel/prompts";
import Box from "ds/components/Box";
import Tooltip from "ds/components/Tooltip";
import Typography from "ds/components/Typography";

type PolicyDetailsAskButtonProps = {
  policyId: string;
};

const PolicyDetailsAskButton = ({ policyId }: PolicyDetailsAskButtonProps) => (
  <Tooltip
    widthMode="maxWidthSm"
    on={(props) => (
      <AssistantPanelAskButton
        {...props}
        entryPoint="policy_overview"
        prompt={buildPolicyOverviewPrompt({ policyId })}
        id="policy-view--ask-infra-assistant"
      />
    )}
  >
    <Box direction="column" gap="small">
      <Typography tag="p">Ask Infra Assistant</Typography>
      <Typography tag="p">
        Get a <b>quick summary</b> of <b>this policy</b>: what it enforces, where it is attached and
        what needs attention.
      </Typography>
    </Box>
  </Tooltip>
);

export default PolicyDetailsAskButton;
